import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-volume-max",
  templateUrl: "./med-icon-volume-max.component.html",
})
export class MedIconVolumeMaxComponent extends SvgMixinComponent {}
